import React from 'react';
import { User, Calendar, Settings, LogOut, ShoppingBag } from 'lucide-react';
import { logout } from '../../../helpers/user';
import { useNavigate } from 'react-router-dom';

const Sidebar = ({ userData, activeTab, onTabChange }) => {
    const navigate = useNavigate();
    const menuItems = [
        { id: 'profile', label: 'Mon profil', icon: User },
        { id: 'bookings', label: 'Mes réservations', icon: ShoppingBag },
        { id: 'workshops', label: 'Mes Ateliers', icon: Calendar },
        { id: 'settings', label: 'Paramètres', icon: Settings },
    ];

    const handleLogout = async () => {
        if (logout()) {
            navigate('/connexion');
        }
    };

    return (
        <div className="card">
            <div className="card-body">
                <div className="text-center mb-4">
                    <div className="avatar mb-3">
                        <div
                            className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center"
                            style={{ width: '80px', height: '80px', margin: '0 auto' }}
                        >
                            {userData?.firstName?.charAt(0)}{userData?.lastName?.charAt(0)}
                        </div>
                    </div>
                    <h5 className="mb-1">{userData?.firstName} {userData?.lastName}</h5>
                    <p className="text-muted small mb-0">{userData?.email}</p>
                </div>

                <div className="list-group list-group-flush">
                    {menuItems.map(item => (
                        <button
                            key={item.id}
                            className={`list-group-item list-group-item-action ${activeTab === item.id ? 'active' : ''}`}
                            onClick={() => onTabChange(item.id)}
                        >
                            <item.icon size={18} className="me-3" />
                            {item.label}
                        </button>
                    ))}
                    <button
                        className={`list-group-item list-group-item-action`}
                        onClick={() => handleLogout()}
                    >
                        <LogOut size={18} className="me-3" />
                        Déconnexion
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Sidebar;